import { render } from "./NFTCard.vue?vue&type=template&id=ee5c51bc&scoped=true&ts=true"
import script from "./NFTCard.vue?vue&type=script&lang=ts"
export * from "./NFTCard.vue?vue&type=script&lang=ts"

import "./NFTCard.vue?vue&type=style&index=0&id=ee5c51bc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee5c51bc"]])

export default __exports__